import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      width={100}
      height={42}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M83.823 12.98C86.358 2.636 95.343-.048 100 0v42H0V0c2.794 0 13.542 2.002 15.882 12.98C23.53 48.854 75 49 83.823 12.98z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgComponent;
